import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { NON_BREAKING_SPACE } from '../../../../constants/constants';
import { setIsAutoChecking } from '../../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { ALERT_BUTTON_BACKGROUND_COLOR_NUM, ALERT_BUTTON_BACKGROUND_HOVER_COLOR_NUM, ALERT_BUTTON_TEXT_COLOR_NUM, AUTO_BET_BUTTON_BACKGROUND_COLOR_NUM, AUTO_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM } from '../../../../styles/colors';
import { Button } from '../../pixiComponents/button';
export const PixiAutoCheckButton = ({ bounds }) => {
    const dispatch = useAppDispatch();
    const isAutoChecking = useAppSelector((state) => state.poker.autoBetProperties?.isAutoChecking);
    const onClickAutoCheck = useCallback(() => {
        dispatch(setIsAutoChecking(!isAutoChecking));
    }, [dispatch, isAutoChecking]);
    // non-breaking space prevents wrapping between checkmark and 'check':
    const label = `${isAutoChecking ? `✓${NON_BREAKING_SPACE}` : ''}CHECK`;
    return (_jsx(Button, { pixiObjectData: { type: 'auto-check-button', isAutoChecking }, onClick: onClickAutoCheck, labelProperties: {
            label,
            bitmapTextStyleType: isAutoChecking ? 'enabled-auto-bet-button-label' : 'auto-bet-button-label',
            labelPixiDataType: 'auto-check-button-label'
        }, bounds: bounds, backgroundColor: isAutoChecking ? ALERT_BUTTON_BACKGROUND_COLOR_NUM : AUTO_BET_BUTTON_BACKGROUND_COLOR_NUM, backgroundHoverColor: isAutoChecking ? ALERT_BUTTON_BACKGROUND_HOVER_COLOR_NUM : AUTO_BET_BUTTON_BACKGROUND_HOVER_COLOR_NUM, lineColor: isAutoChecking ? ALERT_BUTTON_TEXT_COLOR_NUM : undefined, lineWidth: isAutoChecking ? 2 : undefined, paddingH: 1, highlightRatio: 0.6 }));
};
